import { render, staticRenderFns } from "./updateAppoint.vue?vue&type=template&id=a12ab742&scoped=true&"
import script from "./updateAppoint.vue?vue&type=script&lang=js&"
export * from "./updateAppoint.vue?vue&type=script&lang=js&"
import style0 from "./updateAppoint.vue?vue&type=style&index=0&id=a12ab742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12ab742",
  null
  
)

export default component.exports